import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

import {
  assistantMessageResponseSchema,
  filterConditionsSchema,
  userPromptMessageResponseSchema,
} from '../schema';

export const createPromptMessageRequestSchema = z.object({
  message: z.string().min(1),
  filter_conditions: filterConditionsSchema,
});

export const analyzePromptResponseSchema = z.object({
  user_message: userPromptMessageResponseSchema,
  assistant_message: assistantMessageResponseSchema,
});

export type AnalyzePromptResponse = z.infer<typeof analyzePromptResponseSchema>;
export type CreatePromptMessageRequest = z.infer<typeof createPromptMessageRequestSchema>;

export async function analyzePrompt(
  discoverySessionId: string,
  request: CreatePromptMessageRequest,
  signal?: AbortSignal,
): Promise<AnalyzePromptResponse> {
  const parsedRequest = createPromptMessageRequestSchema.parse(request);
  const response = await socialApiClient.post(
    `discovery-sessions/${discoverySessionId}/analyze-prompt`,
    {
      json: parsedRequest,
      signal,
    },
  );

  return await response.json();
}
